import { Link } from "wouter";
import { services } from "@/lib/data";

export default function ServicesSection() {
  return (
    <section id="services" className="py-16 md:py-24 bg-[#f8f9fa]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="section-title">Professional Accounting Services</h2>
          <div className="section-divider"></div>
          <p className="max-w-2xl mx-auto">Comprehensive financial solutions tailored to your industry's unique challenges. Our accounting firm specializes in helping businesses thrive with both in-person and remote accounting services nationwide.</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.slice(0, 9).map((service, index) => (
            <div className="service-card shadow-elegant card-hover-effect" key={index} id={service.id}>
              <div className="relative mb-6 pb-6">
                <div className="w-16 h-16 rounded-full bg-[rgba(125,155,118,0.1)] flex items-center justify-center mx-auto mb-4">
                  <i className={`${service.icon} text-3xl text-[#7d9b76]`}></i>
                </div>
                <h3 className="text-xl font-serif font-bold text-[#1a365d] mb-3 text-center">
                  {service.title}
                </h3>
                <p className="text-center text-gray-600">{service.description}</p>
                <div className="elegant-divider"></div>
              </div>
              <div className="text-center">
                <Link href={`/services#${service.id}`} className="text-[#7d9b76] hover:text-[#1a365d] font-medium transition-colors duration-300 inline-flex items-center">
                  Learn More <i className="fas fa-arrow-right ml-2 text-xs"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12 mb-16">
          <div className="mb-8">
            <h3 className="text-xl font-serif font-bold text-[#1a365d] mb-4">Industries We Serve</h3>
            <div className="flex flex-wrap justify-center gap-3 mt-4">
              <span className="bg-[#1a365d] text-white px-3 py-1 rounded-full text-sm">Law Firms</span>
              <span className="bg-[#1a365d] text-white px-3 py-1 rounded-full text-sm">Construction</span>
              <span className="bg-[#1a365d] text-white px-3 py-1 rounded-full text-sm">Real Estate</span>
              <span className="bg-[#1a365d] text-white px-3 py-1 rounded-full text-sm">Manufacturing</span>
              <span className="bg-[#1a365d] text-white px-3 py-1 rounded-full text-sm">Tech Startups</span>
              <span className="bg-[#1a365d] text-white px-3 py-1 rounded-full text-sm">Healthcare</span>
              <span className="bg-[#1a365d] text-white px-3 py-1 rounded-full text-sm">Professional Services</span>
              <span className="bg-[#1a365d] text-white px-3 py-1 rounded-full text-sm">Agriculture</span>
              <span className="bg-[#1a365d] text-white px-3 py-1 rounded-full text-sm">Retail</span>
              <span className="bg-[#1a365d] text-white px-3 py-1 rounded-full text-sm">Hospitality</span>
              <span className="bg-[#1a365d] text-white px-3 py-1 rounded-full text-sm">E-commerce</span>
              <span className="bg-[#1a365d] text-white px-3 py-1 rounded-full text-sm">Non-Profits</span>
            </div>
          </div>

          <Link 
            href="/booking"
            className="bg-[#7d9b76] hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-md transition-all duration-300 inline-block"
          >
            Schedule a Consultation
          </Link>
        </div>
        
        <div className="mt-16 relative rounded-lg overflow-hidden">
          <div className="absolute inset-0">
            <picture>
              <source srcSet="/images/staff/webp/accounting-calculator.webp" type="image/webp" />
              <source srcSet="/images/staff/accounting-calculator.jpg" type="image/jpeg" />
              <img 
                src="/images/staff/accounting-calculator.jpg" 
                alt="Professional accounting services in Draper, Utah and nationwide | SW Accounting firm" 
                className="w-full h-full object-cover"
                loading="lazy"
                width="1200"
                height="800"
                title="SW Accounting - Premier Accounting Services in Salt Lake County, Utah and Nationwide"
              />
            </picture>
            <div className="absolute inset-0 bg-[#1a365d] opacity-80"></div>
          </div>
          <div className="relative py-12 px-8 text-center">
            <h3 className="text-white font-serif text-3xl font-bold mb-4">
              Trusted Accounting Services
            </h3>
            <p className="text-white max-w-2xl mx-auto mb-6">
              Let our team of accounting professionals handle your business financial needs while you focus on growth. With over 20 years of experience serving clients nationwide with secure, efficient in-person and virtual solutions.
            </p>
            <Link 
              href="/services"
              className="bg-white text-[#1a365d] hover:bg-opacity-90 font-bold py-3 px-6 rounded-md transition-all duration-300 inline-block"
            >
              Explore Our Accounting Services
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
